import { render, staticRenderFns } from "./PreviewFile.vue?vue&type=template&id=2b9de437"
import script from "./PreviewFile.vue?vue&type=script&lang=js"
export * from "./PreviewFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9de437')) {
      api.createRecord('2b9de437', component.options)
    } else {
      api.reload('2b9de437', component.options)
    }
    module.hot.accept("./PreviewFile.vue?vue&type=template&id=2b9de437", function () {
      api.rerender('2b9de437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/modal/PreviewFile.vue"
export default component.exports